export const getAvatarInfo = (firstName, lastName, email) => {
  const colors = ['#F6A5A5', '#57B968', '#B1B2F1', '#9ACAFE', '#FBD872']
  const firstLetter = email.charAt(0).toUpperCase()
  const alphabetPosition = firstLetter.charCodeAt(0) - 'A'.charCodeAt(0) + 1
  const group = Math.ceil(alphabetPosition / 5)
  const badgeColor = colors[group - 1]
  const initials =
    (firstName[0]?.toUpperCase() || '') + (lastName[0]?.toUpperCase() || '')
  return { initials, color: badgeColor }
}
